module.exports = __webpack_public_path__ + "img/regbi-post-min.08af42c8.png";